function warmImage(root, source, alt, imageId, scene, thumb) {
  if (!source) return;
  const gallery = root.querySelector('.wr-gallery');
  const image = gallery?.querySelector('.wr-main-image');
  if (!image) return;
  image.removeAttribute('srcset');
  image.src = source;
  if (alt) image.alt = alt;
  gallery.querySelector('.wr-photo').classList.toggle('wr-photo--scene', scene === 'true');
  const thumbs = Array.from(gallery.querySelectorAll('[data-wr-image]'));
  let active = -1;
  thumbs.forEach((button, index) => {
    const selected = thumb ? button === thumb : button.dataset.wrImageId === imageId;
    button.setAttribute('aria-pressed', String(selected));
    if (selected) active = index;
  });
  const counter = gallery.querySelector('[data-wr-image-index]');
  if (counter) counter.textContent = active >= 0 ? String(active + 1).padStart(2, '0') : '';
}

document.addEventListener('click', event => {
  const thumb = event.target.closest('[data-wr-image]');
  if (!thumb || thumb.tagName !== 'BUTTON') return;
  const root = thumb.closest('[data-wr-purchase]');
  if (root) warmImage(root, thumb.dataset.wrImage, thumb.dataset.wrAlt, thumb.dataset.wrImageId, thumb.dataset.wrScene, thumb);
});

document.addEventListener('change', event => {
  if (!event.target.matches('[data-wr-variant]')) return;
  const root = event.target.closest('[data-wr-purchase]');
  const option = event.target.selectedOptions[0];
  root.querySelector('[data-wr-price]').textContent = option.dataset.price;
  const button = root.querySelector('[data-wr-add]');
  const available = option.dataset.available === 'true';
  button.disabled = !available;
  button.textContent = available ? button.dataset.availableLabel : button.dataset.soldLabel;
  const arrow = document.createElement('span');
  arrow.setAttribute('aria-hidden', 'true');
  arrow.textContent = '↗';
  button.append(arrow);
  const checkout = root.querySelector('[data-wr-checkout]');
  if (checkout) checkout.hidden = !available;
  const quantity = root.querySelector('[data-wr-quantity]');
  if (quantity) {
    quantity.min = option.dataset.quantityMin || '1';
    quantity.step = option.dataset.quantityStep || '1';
    if (option.dataset.quantityMax) quantity.max = option.dataset.quantityMax;
    else quantity.removeAttribute('max');
    quantity.value = quantity.min;
  }
  warmImage(root, option.dataset.wrImage, option.dataset.wrAlt, option.dataset.wrImageId, 'false');
});

function warmOpenAnchor() {
  if (!location.hash) return;
  let id;
  try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
  const target = document.getElementById(id);
  if (target?.matches('details')) target.open = true;
}
window.addEventListener('hashchange', warmOpenAnchor);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', warmOpenAnchor);
else warmOpenAnchor();
document.addEventListener('shopify:section:load', warmOpenAnchor);
document.addEventListener('click', event => {
  const menu = event.target.closest('.wr-mobile-menu');
  if (menu && event.target.closest('a')) menu.open = false;
  document.querySelectorAll('.wr-mobile-menu[open]').forEach(openMenu => {
    if (!openMenu.contains(event.target)) openMenu.open = false;
  });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.wr-mobile-menu[open]').forEach(menu => {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});

if (!customElements.get('wr-sticky-purchase')) {
  customElements.define('wr-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      this.root = Array.from(document.querySelectorAll('[data-wr-section]')).find(section => section.dataset.wrSection === this.dataset.section);
      this.action = this.root?.querySelector('[data-wr-main-action]');
      if (!this.action || !('IntersectionObserver' in window)) return;
      this.mobile = window.matchMedia('(max-width: 899px)');
      this.refresh = () => {
        this.hidden = !(this.mobile.matches && this.action.getBoundingClientRect().bottom < 0);
        document.body.classList.toggle('wr-sticky-space', !this.hidden);
      };
      this.observer = new IntersectionObserver(this.refresh, {threshold: [0, 1]});
      this.observer.observe(this.action);
      this.mobile.addEventListener('change', this.refresh);
      this.refresh();
      this.choose = event => {
        if (!event.target.closest('[data-wr-sticky-link]')) return;
        const form = this.root.querySelector('.wr-form');
        if (!form) return;
        event.preventDefault();
        form.scrollIntoView({block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        form.querySelector('[data-wr-variant], [data-wr-quantity], [data-wr-add]')?.focus({preventScroll: true});
      };
      this.addEventListener('click', this.choose);
      this.variantChange = event => {
        if (!event.target.matches('[data-wr-variant]')) return;
        this.querySelector('[data-wr-sticky-price]').textContent = event.target.selectedOptions[0].dataset.price;
      };
      this.root.addEventListener('change', this.variantChange);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.mobile?.removeEventListener('change', this.refresh);
      this.removeEventListener('click', this.choose);
      if (this.variantChange) this.root?.removeEventListener('change', this.variantChange);
      document.body.classList.remove('wr-sticky-space');
    }
  });
}
